import { useContext, useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { CompetitionContext } from '../Context/CompetitionContext';

const Leagues = () => {
  const context = useContext(CompetitionContext);
  const { id } = useParams();
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getUsers();
      await getCompetitionRegister();
    };
    getData();
  }, [id, search]);

  const getUsers = async () => {
    setLoading(true);
    await get(
      `/league/competition-register/${id}`,
      (res) => {
        context.leagues = res;
      },
      (err) => {
        error('دریافت اطلاعات تیم های لیگ با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getCompetitionRegister = async () => {
    setLoading(true);
    await get(
      `/competition-register/${id}`,
      (res) => {
        context.competitionRegister = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات مسابقه با خطا مواجه شد');
        setLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title={`لیست تیم های لیگ مسابقه ${context.competitionRegister?.competition?.title}`}
          showBackBtn={true}
          showCreateBtn={false}
          showFilterBtn={true}
          backPath={`/competition/competition-register?competition_id=${context.competitionRegister?.competition?.id}`}
        />
        <Datatable
          data={context.leagues?.data}
          editUrl='#'
          meta={context.leagues?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          disableAllActions={true}
          basePagePath={`/competition-register/${id}/legue`}
          columns={['نام تیم', 'استان', 'شرکت کنندگان']}
          rows={[
            { name: 'name', type: 'string' },
            { name: 'province.name', type: 'relation', relType: 'string' },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: `/competition-register/${context.competitionRegister?.id}/league/{id}/users`,
              params: ['id'],
            },
          ]}
        />
      </Master>
    </>
  );
};
export default Leagues;
